import { ChevronLeftIcon, Settings } from 'lucide-react';
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useExposure } from '../../../../../../hooks/useExposure';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #000000;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(50, 55, 56);
  color: white;
  padding: 10px 16px;
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: bold;
  margin-top: -2px;
`;

const FrameContainer = styled.div`
  width: 100%;
  height: 169px;
  overflow: hidden;
`;

const ScoreContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
`;

const ScoreFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  margin-top: 4px;
`;

const StreamContainer = styled.div`
  width: 100%;
  height: 174px;
  overflow: hidden;
  margin-top: 8px;
`;

const StreamWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const StreamFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const PlayButton = styled.button`
  background: #FF5C5C;
  color: black;
  padding: 4px 9px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 10px;
  margin-right: 8px;
  &:hover {
    background: rgb(220, 136, 6);
  }
`;

const SettingsWrapper = styled.div`
  position: relative;
`;

const SettingsButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 0.2s ease;

  &:hover {
    color: #FF5C5C;
  }
`;

const InfoModal = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  background: #1e1e1e;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 8px;
  padding: 12px 16px;
  min-width: 200px;
  color: white;
  font-size: 13px;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.6);
  z-index: 999;
`;

const InfoRow = styled.div`
  margin-bottom: 6px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const MobileLiveInterface = ({ eventId }) => {
  const [showStream, setShowStream] = useState(false);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const history = useHistory();
  const { exposure, totalExposure } = useExposure();

  const toggleStream = () => setShowStream(!showStream);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Container>
      <Header>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <ChevronLeftIcon
            style={{ marginLeft: '-13px', marginTop: '-5px', fontWeight: 'bold' }}
            onClick={() => history.goBack()}
            size={24}
          />
          <Title>Live Score</Title>
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <PlayButton onClick={toggleStream}>
            {showStream ? 'Stop Stream' : 'Play Stream'}
          </PlayButton>

          {/* Settings icon + modal */}
          <SettingsWrapper ref={wrapperRef}>
            <SettingsButton onClick={() => setOpen(prev => !prev)}>
              <Settings size={18} />
            </SettingsButton>
            {open && (
              <InfoModal>
                <InfoRow>Event ID:{eventId}</InfoRow>
                {/* <InfoRow><strong>Stream:</strong> {showStream ? 'Active' : 'Inactive'}</InfoRow> */}
                <InfoRow>Net Exposure: {totalExposure} </InfoRow>
              </InfoModal>
            )}
          </SettingsWrapper>
        </div>
      </Header>

      {showStream && (
        <StreamContainer>
          <StreamWrapper>
            <StreamFrame
              src={`https://live-stream.softgamingapi.com/?eventid=${eventId}`}
              title="Live Stream"
              allowFullScreen
            />
          </StreamWrapper>
        </StreamContainer>
      )}

      <FrameContainer>
        <ScoreContainer>
          <ScoreFrame
            src={`https://betfair-score.softgamingapi.com/?id=${eventId}`}
            title="Live Score"
          />
        </ScoreContainer>
      </FrameContainer>
    </Container>
  );
};

export default MobileLiveInterface;
